/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {MOperationsFullscreenComponent as ɵa} from './operations-fullscreen.component';